export const DEFAULT_LIST_PAGE = 0

export const DEFAULT_LIST_SIZE = 10
export const DEFAULT_EXTENDED_LIST_SIZE = 50
export const DEFAULT_MAX_LIST_SIZE = 1000

export const DEFAULT_LIST_KEY = 'pagination'

export const FETCH_STATUSES = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
}

export const INITIAL_LIST_META = {
  first: true,
  last: false,
  number: 0,
  numberOfElements: 0,
  page: DEFAULT_LIST_PAGE,
  size: DEFAULT_LIST_SIZE,
  sort: {},
  filters: {},
  totalElements: 0,
  totalPages: 0,
  fetchStatus: FETCH_STATUSES.INITIAL,
  fetchStatusError: {},
}

export const INITIAL_LIST_STATE = {
  [DEFAULT_LIST_KEY]: {
    meta: {
      ...INITIAL_LIST_META,
    },
    pages: {
      0: [],
    },
  },
}
